import styled, { css } from 'styled-components';
import {PcBox as BasePcBox, MobileBox as BaseMobileBox} from './game-title.default.box';
import {styledByDevice} from '../../../../../themes/architecture/styled-by-device';
import {Color} from '../../../../../themes/definitions/casino777/casino777-colors';

const common = css`
    color: ${Color.blackTeal};
    font-family: ${({theme}) => theme.font.family.bold};
`;

const PcBox = styled(BasePcBox)`
    ${common}
    font-size: 1.5rem;

`;


const MobileBox = styled(BaseMobileBox)`
    ${common}
    font-size: 1.2rem;

    /* override the BaseMobileBox CSS for small screen */
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        font-size: 1.2rem;
    }

`;


export const GameTitleCasino777Box = styledByDevice(PcBox, MobileBox);
